import {
  PerspectivesConditionalFormatting as PerspectivesConditionalFormattingComponent,
  type ConditionalFormattingProps,
} from '@ardoq/perspectives';
import { DEFAULT_ARDOQ_I18NLOCALE, type I18nLocale } from '@ardoq/i18n';
import { EntityFormattingRule } from './FormattingRuleRow';

export const PerspectivesConditionalFormatting = ({
  colorPaletteAlignment = 'right',
  i18nLocale = DEFAULT_ARDOQ_I18NLOCALE,
  ...props
}: ConditionalFormattingProps & { i18nLocale?: I18nLocale }) => {
  return (
    <PerspectivesConditionalFormattingComponent
      {...props}
      i18nLocale={i18nLocale}
      isSidebar={true}
      isNewConditionalFormatting={true}
    >
      {rule => (
        <EntityFormattingRule
          key={rule.__id}
          formattingRule={rule}
          dragAndDropCardId={rule.__id}
          colorPaletteAlignment={colorPaletteAlignment}
          i18nLocale={i18nLocale}
        />
      )}
    </PerspectivesConditionalFormattingComponent>
  );
};
